/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import Panes from './Panes/index'
import React from 'react'
import TysiaModal from 'DesignSystem/TysiaModal/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/NewPatient/Content"
  
}) {
  return (<React.Fragment
>
<TysiaModal
  viewPath={`${viewPath}/TysiaModal`}
 size="medium"
 height="auto"
>
{childProps => (
<Panes
{...childProps}
  viewPath={`${viewPath}/Panes`}
/>
)}
</TysiaModal>
{children}
</React.Fragment>)
}